module.exports = __webpack_public_path__ + "static/media/Colette Ray Queen Headboard - 155 cm.52757d45.jpg";